"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var xlsx_1 = __importDefault(require("xlsx"));

var FlatFileReader =
/** @class */
function () {
  function FlatFileReader(src) {
    this.rowCount = 0;
    this.colCount = 0;
    this.rowHasMore = false;
    this.colHasMore = false;
    this.itPointer = 1;
    this.headers = [];
    this.withHeader = true;
    this.rowMax = 10000;
    this.colMax = 100;
    this.src = src;
  }

  FlatFileReader.prototype.next = function () {
    var value = this.getRow(this.itPointer, this.colCount);
    var done = false;
    this.itPointer++;

    if (this.itPointer > this.rowCount + (this.headers ? 1 : 0)) {
      done = true;
      this.itPointer = this.withHeader ? 1 : 0;
    }

    return {
      done: done,
      value: value
    };
  };

  FlatFileReader.prototype[Symbol.iterator] = function () {
    this.itPointer = this.withHeader ? 1 : 0;
    return this;
  };

  FlatFileReader.prototype.getRowCount = function () {
    return this.rowCount;
  };

  FlatFileReader.prototype.getColCount = function () {
    return this.colCount;
  };

  FlatFileReader.prototype.getRowHasMore = function () {
    return this.rowHasMore;
  };

  FlatFileReader.prototype.getColHasMore = function () {
    return this.colHasMore;
  };

  FlatFileReader.prototype.getHeaders = function () {
    return this.headers;
  };

  FlatFileReader.prototype.read = function () {
    var _this = this;

    return new Promise(function (res, rej) {
      var reader = new FileReader();

      reader.onload = function (e) {
        var data = new Uint8Array(reader.result);

        try {
          var workbook = xlsx_1.default.read(data, {
            type: "array"
          });

          if (workbook.SheetNames.length < 1) {
            rej("Le fichier semble vide");
            return;
          }

          _this.sheet = workbook.Sheets[workbook.SheetNames[0]];
          var range = xlsx_1.default.utils.decode_range(_this.sheet["!ref"]);
          _this.colCount = range.e.c - range.s.c + 1;
          _this.rowCount = range.e.r - range.s.r + 1;
          _this.colCount = _this.getLine(0).filter(function (v) {
            return v.length > 0;
          }).length;

          while (_this.rowCount > 0 && !_this.getLine(_this.rowCount).filter(function (v) {
            return v.length > 0;
          }).length) {
            _this.rowCount--;
          }

          if (_this.rowCount > _this.rowMax) {
            _this.rowCount = _this.rowMax;
            _this.rowHasMore = true;
          }

          if (_this.colCount > _this.colMax) {
            _this.colCount = _this.colMax;
            _this.colHasMore = true;
          }

          _this.headers = _this.getLine(0, _this.colCount);
          res(_this);
        } catch (e) {
          rej(e);
        }
      };

      reader.onerror = rej;
      reader.readAsArrayBuffer(_this.src);
    });
  };

  FlatFileReader.prototype.generatePreview = function () {
    var _this = this;

    return new Promise(function (res, rej) {
      if (!_this.rowCount) {
        rej("generatePreview : Read file before");
        return;
      }

      var head = [];
      var tail = [];
      var count = _this.rowCount;

      for (var i = 1; i < 4; i++) {
        head.push(_this.getLine(i, _this.getColCount()));
      }

      for (var i = _this.rowCount; i > 3; i--) {
        var row = _this.getLine(i, _this.getColCount());

        if (!row.filter(function (v) {
          return v.length > 0;
        }).length) {
          // Ignore les lignes vides
          count--;
          continue;
        }

        tail.push(row);

        if (tail.length >= 3) {
          break;
        }
      }

      res({
        headers: _this.getHeaders(),
        head: head,
        tail: tail.reverse(),
        count: count
      });
    });
  };

  FlatFileReader.prototype.getRow = function (i, len) {
    var data = this.getLine(i, this.colCount);
    var row = {};

    for (var i_1 = 0; i_1 < data.length; i_1++) {
      row[this.headers[i_1]] = data[i_1];
    }

    return row;
  };

  FlatFileReader.prototype.getLine = function (i, len) {
    if (this.headers) {
      i += 1;
    }

    var data = xlsx_1.default.utils.sheet_to_json(this.sheet, {
      header: 1,
      defval: "",
      raw: false,
      range: {
        s: {
          r: i - 1,
          c: 0
        },
        e: {
          r: i - 1,
          c: this.colCount - 1
        }
      }
    });

    if (len && data[0].length > len) {
      return data[0].slice(0, len);
    }

    return data[0];
  };

  return FlatFileReader;
}();

exports.FlatFileReader = FlatFileReader;